import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/common/arrow-down.svg'


const _withScopeId = n => (_pushScopeId("data-v-936737da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "txuser-summary" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "data-container" }
const _hoisted_6 = { class: "number" }
const _hoisted_7 = { class: "item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "ERC-20 Holdings", -1))
const _hoisted_9 = { class: "data-container" }
const _hoisted_10 = {
  key: 0,
  class: "icon",
  src: _imports_0
}
const _hoisted_11 = {
  key: 0,
  class: "token-list"
}

import { ref, computed } from "vue";
type Token = {
  name: string;
  symbol: string;
  amount: number;
};
interface Props {
  pltBalance: number;
  tokenHoldings: [Token];
}

export default /*#__PURE__*/_defineComponent({
  props: {
    pltBalance: null,
    tokenHoldings: null
  },
  setup(__props: any) {

const props = __props as {
  pltBalance: number;
  tokenHoldings: [Token];
}


const isShowingTokens = ref(false);
const tokensDisplayed = computed(() =>
  props.tokenHoldings.filter((t) => t.amount > 0)
);
const toggle = () => {
  if (tokensDisplayed.value.length > 0)
    isShowingTokens.value = !isShowingTokens.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("txuser.balance")), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(`${__props.pltBalance} PLT`), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: "number token-button",
            onClick: toggle
          }, [
            _createElementVNode("span", null, _toDisplayString(`(${_unref(tokensDisplayed).length} Tokens)`), 1),
            (_unref(tokensDisplayed).length > 0)
              ? (_openBlock(), _createElementBlock("img", _hoisted_10))
              : _createCommentVNode("", true)
          ])
        ]),
        (isShowingTokens.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokensDisplayed), (token) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "token",
                  key: token.symbol
                }, [
                  _createElementVNode("span", null, _toDisplayString(`${token.name} (${token.symbol})`), 1),
                  _createElementVNode("span", null, _toDisplayString(`${token.amount} ${token.symbol}`), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})